import { DashboardWidget } from 'features/widget/types'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import MetricSeries from 'enums/MetricSeries'
import resolveMetricSeriesValue from './metricSeriesValueResolver'
import { isDatasetLanguageNotSupported } from '../../utils/languageNotSupportedChecker'

const isLanguageSupported = (dashboardWidgetData: any) =>
  !isDatasetLanguageNotSupported(dashboardWidgetData!.results![0]!.data!.metrics![0]!.dataset!)

const getMentions = (dashboardWidgetData: any) =>
  resolveMetricSeriesValue(
    dashboardWidgetData!.results![0]!.data!.metrics![0]!.dataset!,
    MetricSeries.TOTAL_BUZZ
  )

const resolveMaxMentionsValue = (searchResult: DashboardWidget<AnnotatedMetricResult>): number =>
  Math.max(...searchResult.data.filter(isLanguageSupported).map(getMentions))

export default resolveMaxMentionsValue
